import * as requestFromServer from "./SubjectOutcomesCrud";
import { callTypes, subjectOutcomeSlice } from "./SubjectOutcomesSlice";

const {actions} = subjectOutcomeSlice;

export const getSubjectOutcomes = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getSubjectOutcomes(queryParams)
    .then(response => {
      dispatch(actions.subjectOutcomesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllSubjectOutcomes = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllSubjectOutcomes(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getsubjectOutcome = (id, subjectId) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
    .getNewSubjectOutcome(subjectId)
    .then(response => {
      dispatch(actions.subjectOutcomeFetched(response.data));
    })
    .catch(error => {
      
    });
  }

  return requestFromServer
    .getSubjectOutcome(id)
    .then(response => {
      dispatch(actions.subjectOutcomeFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveSubjectOutcome = outcome => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveSubjectOutcome(outcome)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteSubjectOutcomes = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteSubjectOutcomes(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanSubjectOutcomesState = () => dispatch => {
  dispatch(actions.subjectOutcomesStateCleaned());
}